import { startOfDay, endOfDay } from 'date-fns'

import { splitPeriodsToGroups } from '../../../../../forms/Multiplatform/MediaOrderForms/ContractBuilder/fields'
import { SHOW_QUOTATIONS_FILTER } from './CalendarBookedMediaFilters/ShowQuotationsFilter'

// const checkIfHasLocationGroup = data => {
//   if (data.length === 1) {
//     // when we have only one group it could be a location group or group without location
//     // so we need to check if it has location group, no location group will have location_name as null
//     return !!data[0]?.location_name
//   } else {
//     return true
//   }
// }

export const getTransformedData = (data, theme) => {
  // Transform all location groups and their products into a flat list of events

  const sortedLocationGroups = [...data].sort((a, b) => {
    if (a.location_name == null) return 1
    if (b.location_name == null) return -1
    return a.location_name.localeCompare(b.location_name)
  })
  const allGroupsEvents = sortedLocationGroups.flatMap(locationGroup => {
    const locationName = locationGroup.location_name

    // Map each product within the location group
    return locationGroup.products.map(product => {
      // Create a product group object
      const productGroup = {
        id: product.product_id,
        name: product.product_name,
        location_name: locationName,
        product_internal_id: product.product_internal_id
      }

      // Return the product group and its associated events
      return {
        group: productGroup,
        events: formatProductEvents(product, theme)
      }
    })
  })

  // Flatten the array of product groups into a single array of events
  return allGroupsEvents
}

export const formatProductEvents = (product, theme) => {
  // Map booked media events, adding timestamps and color
  const bookedMedia =
    product.booked_media?.map(event => ({
      ...event,
      color: theme.brandPrimary, // Assign primary brand color
      start_timestamp: +startOfDay(new Date(event.date_start)), // Convert start date to timestamp
      end_timestamp: +endOfDay(new Date(event.date_end)) // Convert end date to timestamp (end of day)
    })) || [] // Default to an empty array if no booked media

  // Flatten and map quotation periods into events
  const quotations =
    product.quotations?.flatMap(({ periods, ...quotationData }) => {
      // group periods into continuous ranges without gaps
      const groupedPeriods = splitPeriodsToGroups(periods)

      return groupedPeriods.map(periodGroup => ({
        ...quotationData,
        // take the first period as the start date
        date_start: periodGroup[0].date_start,
        // take the last period as the end date
        date_end: periodGroup[periodGroup.length - 1].date_end,
        color: 'orange', // Assign orange color for quotations
        // take the first period as the start date
        start_timestamp: +startOfDay(new Date(periodGroup[0].date_start)), // Convert start date to timestamp
        // take the last period as the end date
        end_timestamp: +endOfDay(new Date(periodGroup[periodGroup.length - 1].date_end)) // Convert end date to timestamp (end of day)
      }))
    }) || [] // Default to an empty array if no quotations

  return [...bookedMedia, ...quotations] // Combine booked media and quotations
}

export const checkIfFiltersAreApplied = filters => {
  // find if there is params and some keys in it once empty object:
  // skip treating the SHOW_QUOTATIONS_FILTER as an added filter
  return filters && Object.keys(filters).filter(key => key !== SHOW_QUOTATIONS_FILTER).length
}
